import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// models
import { ITableColumnTags } from '../models/table';
import { Translates } from '../components/ph-simple-table/translates';
import { MatTooltip } from '@angular/material/tooltip';

const TAG_COLOR: { [key: string]: string } = {
	'green': '#008000',
	'black': '#000000',
	'orange': '#ff5a00'
};

@Directive({
    selector: '[appColorTags]',
    standalone: true
})
export class ColorTagsDirective implements AfterViewInit {

	@Input('appColorTags') tags: ITableColumnTags;

	constructor(
		private elementRef: ElementRef,
		private renderer: Renderer2,
		private translate: TranslateService,
		private matTooltip: MatTooltip
	) {}

	ngAfterViewInit(): void {
		if (!this.tags?.colors) return;

		this.renderer.addClass(this.elementRef.nativeElement, 'color-tags');
		if (this.tags.title) {
			this.translate
				.get(Translates[this.tags.title] || this.tags.title)
				.subscribe((value: string) => {
					this.matTooltip.message = value;
					//this.elementRef.nativeElement.setAttribute('matTooltip', value);
				});
		}
		this.tags.colors.forEach((color: string) => {
			const span: HTMLSpanElement = this.renderer.createElement('span');
			this.renderer.addClass(span, 'color-tag');
			span.style.backgroundColor = TAG_COLOR[color];
			this.renderer.appendChild(this.elementRef.nativeElement, span)
		});
	}
}
